import { render } from "./System_log_view_button.vue?vue&type=template&id=578c6f89&scoped=true"
import script from "./System_log_view_button.vue?vue&type=script&lang=js"
export * from "./System_log_view_button.vue?vue&type=script&lang=js"

import "./System_log_view_button.vue?vue&type=style&index=0&id=578c6f89&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578c6f89"]])

export default __exports__